import getMeses from './getMeses'
import getConsultas from './getConsultas'
import exportConsultas from './exportConsultas'

export const getMesesPromise = getMeses
export const getConsultasPromise = getConsultas
export const exportConsultasPromise = exportConsultas
